<script>
import Vue from 'vue'
import {mapActions} from "vuex";
import util from "../../untils/util";

export default Vue.extend({
  name: "allFaq",
  computed: {
    util() {
      return util
    }
  },
  data() {
    return {
      totalFaqs: 0,
      pageFaqs: 1,
      sizeFaqs: 25,
      faqs: [],
    }
  },
  methods: {
    ...mapActions('faq', ['getAllFaqByPage', 'updateFaq', "deleteFaq"]),
    retrieveAllFaqList() {
      let params = {
        page: this.pageFaqs,
        size: this.sizeFaqs,
      }
      this.getAllFaqByPage({params: params, callback: this.callback})
    },
    callback(resp, status) {
      switch (status) {
        case 'getAllFaqListByPageCallback':
          console.log('getAllFaqListByPageCallback: ', resp.data.list)
          if (resp.code == 0) {
            this.totalFaqs = resp.data.totalRecord
            this.faqs = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'deleteFaqCallback':
          if (resp.code == 0) {
            Utils.alert('', 'FAQ Deleted Successfully!', 'success')
            this.retrieveAllFaqList()
          }
          break;
        default:
          break;
      }
    },
    handleCurrentChange(val) {
      this.pageFaqs = val
      this.retrieveAllFaqList()
    },
    goBack() {
      this.$router.go(-1)
    },
    navigateToCreateFaq() {
      this.$router.push({path: "/faq/create"});
    },
    handleClickEditFaq(val) {
      this.$router.push({path: "/faq/create", query: {faqId: val}});
    },
    handleClickDeleteFaq(val) {
      console.log('handleClickDeleteFaq: ', val);
      this.$confirm('Do you really want to delete?', '', {
        confirmButtonText: 'Confirm', confirmButtonClass: 'confirm-class'
      })
        .then(_ => {
          this.deleteFaq({params: {faqId: val}, callback: this.callback});
        })
        .catch(_ => { });


    },
  },
  mounted() {
    this.retrieveAllFaqList()
  }
})
</script>

<template>
  <div class="referrer_box">
    <el-row>
      <el-col :span="12">
        <span class="page-title">FAQ's</span>
      </el-col>
      <el-col :span="12" class="back-col">
        <span @click="goBack()" class="btn-back"><i class="el-icon-arrow-left"></i>BACK</span>
      </el-col>
    </el-row>
    <el-row style="display: flex; align-items: end; margin-top: 15px">
      <el-col :span="4">
        <el-button class="create-faq-btn" @click="navigateToCreateFaq"
        >Create FAQ</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="faqs"
          style="width: 100%;">
          <el-table-column
            prop="position"
            min-width="50"
            label="Position">
          </el-table-column>
          <el-table-column
            prop="question"
            min-width="150"
            label="Question">
          </el-table-column>
          <el-table-column
            prop="answer"
            min-width="200"
            label="Answer">
          </el-table-column>
          <el-table-column
            prop="created"
            min-width="100"
            v-slot="scope"
            label="Created Date">
            <span>{{
                util.formatDate(scope.row.created)
              }}</span>
          </el-table-column>
          <el-table-column
            min-width="80px"
            label="Actions"
          >
            <template v-slot="action">
              <el-button
                class="edit-link"
                @click="handleClickEditFaq(action.row.faqId)"
                type="text"
                size="small"
                icon="el-icon-edit"
              >Edit</el-button
              >
              <span class="divider"> | </span>
              <el-button
                class="remove-link"
                @click="handleClickDeleteFaq(action.row.faqId)"
                type="text"
                size="small"
                icon="el-icon-delete"
              >Delete</el-button
              >
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="address"-->
<!--            min-width="250"-->
<!--            label="Actions">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button class="btn-link" @click="showDetail(1,scope.row)" type="text" icon="el-icon-view">View-->
<!--                Property-->
<!--              </el-button>-->
<!--              <span class="divider"> | </span>-->
<!--              <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <div class="fen" v-if="totalFaqs">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageFaqs"
            :page-size="25"
            layout="total, prev, pager, next"
            :total="totalFaqs">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.referrer_box {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}

.back-col {
  display: flex;
  justify-content: flex-end;
}

.btn-back {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
  text-decoration: underline;
  cursor: pointer;
}

.page-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}

.create-faq-btn {
  color: #ffffff;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  font-weight: 600;
  font-size: 20px;
  width: 100%;
  padding: 10px 0;
}

.edit-link {
  color: #003333;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  text-decoration-line: underline;
}

.edit-link:hover {
  color: #ffbf02;
}

.remove-link:hover {
  color: #ec0e0e;
}

.remove-link {
  color: #003333;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  text-decoration-line: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/faq/allFaq.vue